import { useState } from 'react';

import styles from '../PasswordManagement.module.less';

import {
    Alert,
    Button,
    CallToAction,
    Col,
    FormControl,
    FormikForm,
    Row
} from '$HVUI';
import { useFetch } from '$Hooks';
import yup from '$Validation/yup';

const { number, object, string } = yup;

const validationSchema = object().shape({
    password: string().passwordStrength(3),
    'confirm-password': string().confirmPassword('password'),
    password_score: number()
});

const ProviderConfirmForm = props => {
    const [success, setSuccess] = useState(false);
    const { pathname } = props;

    // post password to pathname
    const { error, loading, post, response } = useFetch(pathname);

    if (success) {
        return (
            <div style={{ marginTop: '1rem', textAlign: 'center' }}>
                <Row gutter={[0, 24]} align="center" justify="center">
                    <Col>
                        <h1 style={{ marginBottom: '1rem' }}>
                            Your account has been confirmed.
                        </h1>
                        <p>You may now sign in.</p>
                    </Col>
                </Row>
                <Row align="center" justify="center">
                    <Col>
                        {/* can't be a <Link> because there's no router here */}
                        <CallToAction
                            text="Home"
                            href="/signin"
                            color="ocean"
                            level="primary"
                        />
                    </Col>
                </Row>
            </div>
        );
    }

    return (
        <div className={styles['confirm-container']}>
            {error && (
                <Alert
                    message="Sorry, we can't set your password right now. Please refresh or try again later."
                    style={{ marginBottom: '1.5rem' }}
                    type="error"
                />
            )}
            <Row gutter={48} align="center">
                <Col md={12}>
                    <h1>Welcome to Healthvana</h1>
                    <p>Here are some tips for creating a secure password:</p>
                    <ul>
                        <li className={styles['list-item']}>
                            Don’t use any words that contain information about
                            you, especially something someone could look up.
                        </li>
                        <li className={styles['list-item']}>
                            Unusual words are best.
                        </li>
                        <li className={styles['list-item']}>
                            The longer the password, the better. Using more than
                            one word to lengthen the password is a great idea.
                        </li>
                    </ul>
                </Col>
                <Col md={12}>
                    <FormikForm
                        initialValues={{
                            password: '',
                            'confirm-password': '',
                            password_score: 0
                        }}
                        onSubmit={async (values, actions) => {
                            const {
                                password: new_password1,
                                'confirm-password': new_password2
                            } = values;
                            await post({
                                new_password1,
                                new_password2
                            });
                            if (response.ok) {
                                setSuccess(true);
                            }
                        }}
                        validationSchema={validationSchema}
                    >
                        <FormControl
                            disabled={loading}
                            name="password"
                            type="password"
                            label="Password"
                            useStrengthMeter={true}
                        />
                        <FormControl
                            disabled={loading}
                            name="confirm-password"
                            type="password"
                            label="Confirm Password"
                        />
                        <Button
                            {...props}
                            disabled={loading}
                            id="button-submit"
                            type="submit"
                            level="primary"
                            text="Confirm account"
                        />
                    </FormikForm>
                </Col>
            </Row>
        </div>
    );
};

export default ProviderConfirmForm;
